import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.59 1.246a3.122 3.122 0 0 1 4.415 4.415l-6.324 6.324c-.36.36-.574.574-.81.758q-.42.327-.9.556c-.27.13-.556.224-1.04.386l-2.222.74-.534.178a1.207 1.207 0 0 1-1.527-1.526l.918-2.756c.162-.485.257-.77.386-1.04a5 5 0 0 1 .556-.9c.185-.237.398-.45.759-.811zM2.686 13.38l1.895-.632c.527-.175.751-.251.96-.35q.381-.183.715-.443c.182-.142.35-.308.743-.701l5.047-5.047a4.9 4.9 0 0 1-1.838-1.163 4.9 4.9 0 0 1-1.163-1.837L3.999 8.252c-.393.393-.56.561-.702.743a4 4 0 0 0-.442.715c-.1.21-.175.433-.351.96l-.631 1.895zm7.17-10.984c.023.116.062.275.126.46.145.418.418.966.933 1.48a3.9 3.9 0 0 0 1.481.934c.185.065.344.103.46.126l.442-.441a2.122 2.122 0 0 0-3-3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }